import { ReloadableTypeId as ReloadableTypeId$1, auto as auto$1, autoFromConfig as autoFromConfig$1, get as get$1, manual as manual$1, reload as reload$1, reloadableTag, reloadFork as reloadFork$1 } from '../../internal/reloadable.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const ReloadableTypeId = ReloadableTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Reloadable` is an implementation of some service that can be dynamically
 * reloaded, or swapped out for another implementation on-the-fly.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Makes a new reloadable service from a layer that describes the construction
 * of a static service. The service is automatically reloaded according to the
 * provided schedule.
 *
 * @since 2.0.0
 * @category constructors
 */
const auto = auto$1;

/**
 * Makes a new reloadable service from a layer that describes the construction
 * of a static service. The service is automatically reloaded according to a
 * schedule, which is extracted from the input to the layer.
 *
 * @since 2.0.0
 * @category constructors
 */
const autoFromConfig = autoFromConfig$1;

/**
 * Retrieves the current version of the reloadable service.
 *
 * @since 2.0.0
 * @category getters
 */
const get = get$1;

/**
 * Makes a new reloadable service from a layer that describes the construction
 * of a static service.
 *
 * @since 2.0.0
 * @category constructors
 */
const manual = manual$1;

/**
 * Reloads the specified service.
 *
 * @since 2.0.0
 * @category constructors
 */
const reload = reload$1;

/**
 * @since 2.0.0
 * @category context
 */
const tag = reloadableTag;

/**
 * Forks the reload of the service in the background, ignoring any errors.
 *
 * @since 2.0.0
 * @category constructors
 */
const reloadFork = reloadFork$1;

export { ReloadableTypeId, auto, autoFromConfig, get, manual, reload, reloadFork, tag };
